var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-hour-record-audit",
    },
    [
      _c("div", { staticClass: "title font-size-16 font-bolder lh28" }, [
        _c("div", { staticClass: "ellipsis" }, [
          _vm._v(_vm._s(_vm.info.trainName)),
        ]),
      ]),
      _c(
        "yxt-row",
        [
          _c("yxt-col", { staticClass: "mt15", attrs: { span: 8 } }, [
            _vm._v(
              "\n      培训类别：" +
                _vm._s(["线上", "线下"][_vm.info.trainType]) +
                "\n    "
            ),
          ]),
          _c("yxt-col", { staticClass: "mt15", attrs: { span: 12 } }, [
            _vm._v(
              "\n      学时：" + _vm._s(_vm.info.trainHour) + "学时\n    "
            ),
          ]),
          _c("yxt-col", { staticClass: "mt15", attrs: { span: 24 } }, [
            _vm._v(
              "\n      地点：" + _vm._s(_vm.info.trainAddress || "-") + "\n    "
            ),
          ]),
          _c("yxt-col", { staticClass: "mt15", attrs: { span: 24 } }, [
            _vm._v(
              "\n      培训时间：" +
                _vm._s(
                  _vm.info.startDate
                    ? _vm.dayjs(_vm.info.startDate).format("YYYY-MM-DD HH:mm")
                    : "-"
                ) +
                "\n      至\n      " +
                _vm._s(
                  _vm.info.endDate
                    ? _vm.dayjs(_vm.info.endDate).format("YYYY-MM-DD HH:mm")
                    : "-"
                ) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "file-list" },
        [
          _vm._l(_vm.imgFileList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "file-list-item mr20 br8" },
              [
                _c(
                  "div",
                  { staticClass: "mt15 img-content bg-gray-2" },
                  [
                    item.fileType && item.fileSuffix !== "img"
                      ? _c("yxt-svg", {
                          staticClass: "ml25",
                          attrs: {
                            "icon-class": _vm.formatIconName(item),
                            "remote-url": _vm.iconUrl,
                            width: "50",
                          },
                        })
                      : _c("img", {
                          staticClass: "img-upload",
                          attrs: { src: item.fileUrl },
                        }),
                    _c("div", { staticClass: "mark" }, [
                      _c("i", {
                        staticClass: "yxt-icon-view hand",
                        on: {
                          click: function ($event) {
                            return _vm.toPreview(item)
                          },
                        },
                      }),
                      _c("i", {
                        staticClass: "yxt-icon-download ml30 hand",
                        on: {
                          click: function ($event) {
                            return _vm.toDown(item)
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "yxt-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: item.fileName,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "mt10 file-name ellipsis" }, [
                      _vm._v(
                        "\n          " + _vm._s(item.fileName) + "\n        "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _c("yxtbiz-image-viewer", {
            ref: "imageViewer",
            attrs: {
              data: _vm.info.imgFileList.map(function (item) {
                return {
                  url: item.fileUrl,
                }
              }),
              showNavbar: false,
              "no-list": "",
              showToolbar: true,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }